<template>
  <div class="row">
    <div class="col-12">
      <card>
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="filter">
            <filter-component
              :isRequiredFarms="true"
              :isMultipleFarms="true"
              @filter="handleFilter"
              @showHideLoading="showHideLoading"
              :classFarms="`col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3`"
              :classLots="`col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3`"
            >
              <template slot="prev">
                <div
                  :class="`col-12 col-sm-12 col-md-6 col-lg-2 col-xl-2 pt-3`"
                >
                  <label>{{ $t('audit.type') }}</label>
                  <br />
                  <el-switch
                    @change="getEvaluationByAuditType()"
                    v-model="typeLotOrFarm"
                    :active-text="`${$t('common_words.allotment')}`"
                    :inactive-text="`${$t('common_words.farm')}`"
                    style="margin-left: 1rem"
                    active-color="#6BA652"
                    inactive-color="#ff4949"
                  >
                  </el-switch>
                </div>
                <div
                  :class="`col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 pt-3`"
                >
                  <label for="">{{ $t('common_words.evaluations') }}: * </label>
                  <br />
                  <el-select
                    @change="
                      selectAllFromSelect(
                        'evaluation_id',
                        evaluationsByCatchType
                      )
                    "
                    clearable
                    collapse-tags
                    style="width: 100%"
                    filterable
                    multiple
                    class="select-primary custom-width-select shadow-sm required-evaluation_id"
                    v-model="evaluation_id"
                    :placeholder="`${$t('common_words.select')}...`"
                  >
                    <el-option
                      class="select-primary selected-all"
                      v-for="item in evaluationsByCatchType"
                      :key="item.id + item.name"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </template>
              <template slot="after-lot">
                <div
                  :class="`col-12 col-sm-12 col-md-6 ${
                    isInspectionForLot
                      ? 'col-lg-4 col-xl-4'
                      : 'col-lg-3 col-xl-3'
                  } pt-3`"
                >
                  <label for="">{{ $t('audit.calculate_na') }}: * </label>
                  <br />
                  <el-select
                    clearable
                    collapse-tags
                    style="width: 100%"
                    filterable
                    class="select-primary custom-width-select shadow-sm required-calculation_type_NA"
                    v-model="calculation_type_NA"
                    :placeholder="`${$t('common_words.select')}...`"
                  >
                    <el-option
                      class="select-primary"
                      v-for="item in getCalculationTypeNA"
                      :key="item.id + item.label"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </template>
              <template v-if="isInspectionForLot" slot="after-lot">
                <div
                  :class="`col-12 col-sm-12 col-md-6 ${
                    isInspectionForLot
                      ? 'col-lg-4 col-xl-4'
                      : 'col-lg-4 col-xl-4'
                  } pt-3`"
                >
                  <label for="">{{ $t('audit.calculation_type') }}: * </label>
                  <br />
                  <el-select
                    clearable
                    collapse-tags
                    style="width: 100%"
                    filterable
                    class="select-primary custom-width-select shadow-sm required-calculation_type"
                    v-model="calculation_type"
                    :placeholder="`${$t('common_words.select')}...`"
                  >
                    <el-option
                      class="select-primary"
                      v-for="item in getCalculationType"
                      :key="item.id + item.name"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </template>
              <template v-if="isInspectionForLot" slot="after-lot">
                <div
                  :class="`col-12 col-sm-12 col-md-6 ${
                    isInspectionForLot
                      ? 'col-lg-4 col-xl-4'
                      : 'col-lg-4 col-xl-4'
                  } pt-3`"
                >
                  <label for=""
                    >{{ $t('common_words.report_typeof') }}: *
                  </label>
                  <br />
                  <el-select
                    clearable
                    collapse-tags
                    style="width: 100%"
                    filterable
                    class="select-primary custom-width-select shadow-sm required-report_typeof"
                    v-model="report_typeof"
                    :placeholder="`${$t('common_words.select')}...`"
                  >
                    <el-option
                      class="select-primary"
                      v-for="item in getReportTypeOf"
                      :key="item.id + item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </template>
              <template v-if="haveRangeColor" slot="after-lot">
                <div
                  :class="`col-12 col-sm-12 col-md-6 ${
                    isInspectionForLot
                      ? 'col-lg-4 col-xl-4'
                      : 'col-lg-4 col-xl-4'
                  } pt-3`"
                >
                  <label for="">{{ $t('common_words.color_range') }}: * </label>
                  <br />
                  <el-select
                    clearable
                    collapse-tags
                    @change="handleRangeColor(range_color_select)"
                    style="width: 100%"
                    filterable
                    class="select-primary custom-width-select shadow-sm required-range_color_select"
                    v-model="range_color_select"
                    :placeholder="`${$t('common_words.select')}...`"
                  >
                    <el-option
                      class="select-primary"
                      v-for="item in rangeColorsByModule"
                      :key="item.id + item.name"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </template>
            </filter-component>
          </el-collapse-item>
        </el-collapse>
      </card>
    </div>
    <div class="col-12">
      <div v-if="haveData">
        <RangeColorLegend
          :haveRangeColor="haveRangeColor"
          :rangeColor="range_color_select_data"
          :isPercentage="true"
        ></RangeColorLegend>

        <card>
          <el-collapse class="custom-el-collapse" v-model="activeFarm">
            <el-collapse-item
              class="custom-collapse-item collapse-data"
              v-for="(farms, index) in tableData"
              :name="(farms.farm_id || '').toString()"
              :key="index"
            >
              <template slot="title">
                <span style="text-transform: capitalize">
                  <strong>{{ $t('common_words.farm') }}: </strong>
                  {{ farms.farm_name }}
                </span>
              </template>
              <div class="table-responsive center">
                <div>
                  <el-collapse
                    class="custom-el-collapse"
                    v-model="activeEvaluation"
                  >
                    <el-collapse-item
                      class="custom-collapse-item collapse-data p-3"
                      v-for="(evaluations, index2) in farms['evaluations']"
                      :name="(evaluations.evaluation_id || '').toString()"
                      :key="index2"
                    >
                      <template slot="title">
                        <span style="text-transform: capitalize">
                          <strong>{{ $t('audit.audit') }}: </strong>
                          {{ evaluations.evaluation_name }}
                        </span>
                      </template>
                      <div
                        v-for="(records, index3) in evaluations['records']"
                        :key="index3"
                      >
                        <table
                          class="table table-striped table-bordered not-last-td table-data mt-3 mb-5"
                        >
                          <thead>
                            <tr class="cusmtom-thead-color">
                              <th
                                colspan="4"
                                scope="col"
                                class="text-center p-3 custom-header-label"
                              >
                                <strong>
                                  {{ $t('common_words.farm') }}:
                                  {{ tableData[index].farm_name }}
                                  {{
                                    records.lot_name
                                      ? '- ' +
                                        $t('calibration.block_or_sector') +
                                        ': ' +
                                        records.block_name +
                                        '-'
                                      : ''
                                  }}
                                  {{
                                    records.lot_name
                                      ? $t('common_words.allotment') +
                                        ': ' +
                                        records.lot_name
                                      : ''
                                  }}
                                </strong>
                              </th>
                            </tr>
                            <tr class="cusmtom-thead-color">
                              <th
                                scope="col"
                                class="text-center p-3 custom-header-label"
                              >
                                <strong>
                                  {{ $t('common_words.sub_category') }}</strong
                                >
                              </th>
                              <th
                                scope="col"
                                class="text-center p-3 custom-header-label"
                              >
                                <strong>
                                  {{
                                    $t('common_words.compliance_percentage')
                                  }}</strong
                                >
                              </th>
                              <th
                                scope="col"
                                class="text-center p-3 custom-header-label"
                                style="width: 600px"
                              >
                                <strong>
                                  {{ $t('common_words.observations') }}</strong
                                >
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(
                                subcategory, index4
                              ) in records.subcategory"
                              :key="index4"
                            >
                              <td>{{ subcategory.name }}</td>
                              <td
                                v-if="haveRangeColor"
                                :class="`text-center`"
                                :style="`border-bottom: 4px solid ${getBackgroudColorByRangeColor(
                                  subcategory.total_compliance
                                )}`"
                              >
                                {{
                                  subcategory.is_all_NA
                                    ? '---'
                                    : parseFloat(
                                        subcategory.total_compliance
                                      ).toFixed(2) + '%'
                                }}
                              </td>
                              <td
                                v-else
                                :class="`text-center ${getTotalComplianceColor(
                                  subcategory.total_compliance
                                )}`"
                              >
                                {{
                                  subcategory.is_all_NA
                                    ? '---'
                                    : parseFloat(
                                        subcategory.total_compliance
                                      ).toFixed(2) + '%'
                                }}
                              </td>
                              <td>
                                {{ subcategory.all_observations }}
                              </td>
                            </tr>
                            <tr class="cusmtom-thead-color">
                              <td class="text-center" colspan="2">
                                <strong>{{
                                  $t('audit.total_compliance_percentage')
                                }}</strong>
                              </td>
                              <td
                                v-if="haveRangeColor"
                                class="text-center"
                                :style="`border-bottom: 4px solid ${getBackgroudColorByRangeColor(
                                  records.final_lot_percentage
                                )}`"
                              >
                                <strong>
                                  {{
                                    getTotalCompliance(
                                      records.final_lot_percentage
                                    )
                                  }}%
                                </strong>
                              </td>
                              <td
                                v-else
                                :class="`text-center ${getColorType(
                                  records.final_lot_percentage
                                )}`"
                              >
                                <strong>
                                  {{
                                    getTotalCompliance(
                                      records.final_lot_percentage
                                    )
                                  }}%
                                </strong>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </el-collapse-item>
                  </el-collapse>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
          <div class="d-flex justify-content-center">
            <export-tables
              :pdf="{
                filename: `${$t(
                  'common_words.general_report'
                )}_${dateToday}.pdf`,
                route: 'advanced/audits/generalreport/pdf',
                paramMethod: 'POST',
                plusData: { ...getDataToExport },
              }"
              :xls="{
                filename: `${$t(
                  'common_words.general_report'
                )}_${dateToday}.xlsx`,
                route: 'advanced/audits/generalreport/excel',
                paramMethod: 'POST',
                plusData: { ...getDataToExport },
              }"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { getDateToday } from 'src/util/Util';
import { isset } from 'src/util/Util';
import Filter from 'src/components/Filter/Filters.vue';
import i18n from 'src/i18n';
import Legend from 'src/views/Pages/Dashboard/AdvancedAudit/Components/Legend.vue';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import RangeColorLegend from 'src/components/RangeColorLegend.vue';
import SweetAlert from 'src/class/Alerts';

export default {
  components: {
    [Filter.name]: Filter,
    Legend,
    RangeColorLegend,
  },
  data() {
    return {
      valueCollapse: null,
      activeName: 'filter',
      activeFarm: [],
      activeEvaluation: [],
      evaluations: [],
      evaluationsByCatchType: [],
      rangeColorsByModule: [],
      tableData: [],
      haveData: false,
      range_color_select: null,
      range_color_select_data: null,
      haveRangeColor: false,
      evaluation_id: null,
      calculation_type_NA: 'Sin NA',
      calculation_type: 0,
      typeLotOrFarm: 0,
      report_typeof: 'detailed',
      data_export: null,
      model: {},
      isInspectionForLot: false,
    };
  },
  mixins: [MixinMasters, MixinPermissions, MixinMenu, MixinForm],
  computed: {
    dateToday() {
      return getDateToday();
    },
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
    getCalculationType() {
      return [
        { id: 0, value: 'withoutArea', name: i18n.t('audit.without_lot_area') },
        { id: 1, value: 'withArea', name: i18n.t('audit.with_lot_area') },
      ];
    },
    getCalculationTypeNA() {
      return [
        {
          id: 0,
          value: 'Sin NA',
          label: i18n.t('audit.calculation_without_na'),
        },
        { id: 1, value: 'Con NA', label: i18n.t('audit.calculation_with_na') },
      ];
    },
    getReportTypeOf() {
      return [
        {
          id: 0,
          value: 'consolidated',
          label: i18n.t('common_words.consolidated'),
        },
        {
          id: 1,
          value: 'detailed',
          label: i18n.t('common_words.detailed'),
        },
      ];
    },
    getDataToExport() {
      const response = { ...this.data_export };
      delete response.route;

      return response;
    },
  },
  watch: {
    '$i18n.locale': ['getSelectAll'],
  },
  methods: {
    getSelectAll() {
      this.evaluations = this.concatAll(this.evaluations.splice(1));
    },
    handleFilter(data) {
      this.dataFilter = { ...data };
      this.activeFarm = [];
      this.activeEvaluation = [];
      this.getData();
    },
    handleCollapse(val) {
      this.valueCollapse = val;
    },
    getData() {
      if (!isset(this.evaluation_id)) {
        return this.validationInputsRequired('evaluation_id');
      } else if (!isset(this.calculation_type_NA)) {
        return this.validationInputsRequired('calculation_type_NA');
      } else if (!isset(this.calculation_type)) {
        return this.validationInputsRequired('calculation_type');
      } else if (!isset(this.report_typeof)) {
        return this.validationInputsRequired('report_typeof');
      } else if (!isset(this.range_color_select)) {
        this.haveRangeColor = false;
      }
      this.showHideLoading(true);
      let data = this.dataFilter;
      if (data.bySel === 'Año') {
        data.datei += '-01-01';
        data.datef += '-12-31';
      }
      data.evaluation_id = this.evaluation_id;
      data.calculation_type = this.calculation_type;
      data.calculation_type_NA = this.calculation_type_NA;
      data.report_typeof = this.report_typeof;
      data.type_lot_or_farm = this.typeLotOrFarm;
      data.route = 'advanced/audits/generalreport';
      this.data_export = data;
      Axios.postMasters(data)
        .then((response) => {
          this.tableData = response.data.data;
          if (this.tableData.length == 0) {
            SweetAlert.warning(i18n.t('common_words.unavailable_data'));
            this.haveData = false;
          } else {
            this.haveData = true;

            for (
              let indexFarm = 0;
              indexFarm < this.tableData.length;
              indexFarm++
            ) {
              const evaluation = this.tableData[indexFarm];
              const farmId = evaluation.farm_id;
              this.activeFarm.push(farmId.toString());
              const dataEvaluation = evaluation.evaluations;

              for (
                let indexEvaluation = 0;
                indexEvaluation < dataEvaluation.length;
                indexEvaluation++
              ) {
                const evaluationId =
                  dataEvaluation[indexEvaluation].evaluation_id;
                this.activeEvaluation.push(evaluationId.toString());
              }
            }
          }
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },
    getTotalCompliance(finalPercentage) {
      return finalPercentage.toFixed(2);
    },
    getColorType(finalPercentage) {
      const percentage = this.getTotalCompliance(finalPercentage);

      return this.getColor(percentage);
    },
    getColor(percentage) {
      if (percentage < 86) {
        return 'danger-value';
      } else if (percentage >= 86 && percentage <= 90) {
        return 'warning-value';
      } else if (percentage >= 91 && percentage < 95) {
        return 'success-value';
      } else {
        return 'successfully-value';
      }
    },
    getTotalComplianceColor(totalCompliance) {
      return this.getColor(totalCompliance);
    },
    handleRangeColor(rengeColorId) {
      if (!isset(this.range_color_select)) {
        this.haveData = false;
      }
      this.range_color_select_data = this.rangeColorsByModule.find(
        (range) => range.id == rengeColorId
      );
    },
    compareWithOperator(value, operator, limit) {
      switch (operator) {
        case '>':
          return value > limit;
        case '>=':
          return value >= limit;
        case '<':
          return value < limit;
        case '<=':
          return value <= limit;
        case '==':
        case '=':
          return value === limit;
        default:
          return false;
      }
    },
    getValueByRangeColor(totalCompliance) {
      const rangesDetails =
        this.range_color_select_data &&
        this.range_color_select_data.range_color_details
          ? this.range_color_select_data.range_color_details
          : [];
      const value = parseFloat(totalCompliance);

      for (let index = 0; index < rangesDetails.length; index++) {
        const detail = rangesDetails[index];
        const from = parseFloat(detail.from);
        const to = parseFloat(detail.to);
        const fromOp = detail.from_operator;
        const toOp = detail.to_operator;

        const passTo = this.compareWithOperator(value, toOp, to);
        if (!passTo) {
          continue;
        }
        const passFrom = this.compareWithOperator(value, fromOp, from);
        if (!passFrom) {
          continue;
        }

        return detail;
      }

      return null;
    },
    getBackgroudColorByRangeColor(totalCompliance) {
      const backgroundColor = this.getValueByRangeColor(totalCompliance);
      return backgroundColor ? backgroundColor.background_color : '';
    },
    getEvaluationByAuditType() {
      this.evaluation_id = [];
      let catch_type = 0;
      this.report_typeof = 'detailed';
      if (this.typeLotOrFarm == 0) {
        this.isInspectionForLot = false;
        catch_type = 2;
      } else {
        this.isInspectionForLot = true;
        catch_type = 1;
      }
      const evaluationType = this.evaluations.filter(
        (evaluation) => evaluation.catch_type == catch_type
      );
      this.evaluationsByCatchType = this.concatAll(evaluationType);
    },
  },
  created() {
    if (this.isIndex()) {
      const urlModule = sessionStorage.getItem('urlModule');
      let data = {};
      data.route = 'rangecolorheaders/reports';
      data.urlModule = urlModule.replace(/^\/+/, '');
      Promise.all([
        Axios.getMasters('advanced/audits/inspections'),
        Axios.postMasters(data),
      ])
        .then(([responseEvaluations, responseRangeColors]) => {
          this.evaluations = responseEvaluations.data.data;
          this.rangeColorsByModule = responseRangeColors.data.data;
          this.getEvaluationByAuditType();

          if (this.rangeColorsByModule.length) {
            const rangeLenghts = this.rangeColorsByModule.length;
            if (rangeLenghts >= 1) {
              this.haveRangeColor = true;
              this.range_color_select = this.rangeColorsByModule[0].id;
              this.range_color_select_data = this.rangeColorsByModule[0];
            }
          }
        })
        .catch((error) => this.showMessageErrors(error));
    } else {
      this.showHideLoading();
    }
  },
  mounted() {
    this.selectedItemOnMenu('advanced');
  },

  destroyed() {
    this.deselectedItemOnMenu('advanced');
  },
};
</script>
<style scoped>
.danger-value {
  border-bottom: 4px solid #ff0000 !important;
}
.warning-value {
  border-bottom: 4px solid #ffff00 !important;
}
.success-value {
  border-bottom: 4px solid #008000 !important;
}
.successfully-value {
  border-bottom: 4px solid #0000ff !important;
}
</style>
